import { MatchPicksModel } from "../../../../api/repositories/stats/models/matches"
import { localize } from "../../../../common/services/localization"
import { getValueOrDefault } from "../../../../common/utils"
import { HeroImage } from "../../ui/file-contents"
import { Table } from "../../ui/tables"

export const PicksBlock: React.FC<{
    picks: MatchPicksModel[]
    isDuo: boolean
    className?: string
}> = ({ picks, className }) => {
    return picks && picks.length > 0
        ? <div className={`w-screen 2xl:w-[420px] max-w-[420px] h-[100%] flex flex-col gap-[12px] ${className}`}>
            <span className="uppercase font-semibold">
                {localize('Pick order / Banned hero')}
            </span>
            <Table
                className="font-['Roboto']"
                headClassName="text-center text-[16px] uppercase"
                bodyClassName="text-center text-[14px]"
                cols={[
                    { headLocalName: "NUMBER", className: "pl-[24px] w-[90px] text-start font-normal" },
                    { headLocalName: "HERO", className: "text-center font-normal" },
                    { headLocalName: "BAN", className: "text-center font-normal" },
                ]}
                rows={
                    picks.map((player, i) => ({
                        className: `${i == picks.length - 1 ? '' : 'border-b-dark'}`,
                        cols: [
                            { value: player.number + 1, className: 'w-[90px] text-center font-normal' },
                            {
                                value: <div className="flex justify-center">
                                    <HeroImage className="h-[40px]" size='80x47' heroName={player.heroName} />
                                </div>,
                                className: ''
                            },
                            {
                                value: <div className="flex justify-center">
                                    {player.ban ?
                                        <HeroImage className="h-[40px]" size='80x47' heroName={player.ban} />
                                        : getValueOrDefault()}
                                </div>,
                                className: ''
                            },
                        ],
                    }))
                }
            />
        </div>
        : null
}